import { useToast, useModal, ModalBase, PushButton } from "tailvue";
import { defineNuxtPlugin } from "#app";
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide("toast", useToast());
  nuxtApp.provide("modal", useModal());
  nuxtApp.vueApp.component("PushButton", PushButton);
  nuxtApp.vueApp.component("ModalBase", ModalBase);
});
